import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLineJobReconciliation = (state, { reconciliationData }) => {
  return state.merge({ reconciliationData });
};

const setAccumulationLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const setAutoReconcileLoader = (state, { showAutoReconcileLoader }) => {
  return state.merge({ showAutoReconcileLoader });
};
const setAccumulationsForNewJob = (state, { accumulationForNewJob }) => {
  return state.merge({ accumulationForNewJob });
};
const setLineJobEquipmentShifts = (state, { lineJobEquipmentShifts }) => {
  return state.merge({ lineJobEquipmentShifts });
};
const setLineJobShifts = (state, { lineJobShifts }) => {
  return state.merge({ lineJobShifts });
};
const setLineJobEquipmentShiftsLoader = (state, { lineJobEquipmentShiftsLoader }) => {
  return state.merge({ lineJobEquipmentShiftsLoader });
};
const setCurrentAccumulation = (state, { currentAccumulation }) => {
  return state.merge({ currentAccumulation });
};
const setAccumulationModalLoader = (state, { accumulationModalLoader }) => {
  return state.merge({ accumulationModalLoader });
};
const setLineJobTotalAccumulation = (state, { lineJobTotalAccumulation }) => {
  return state.merge({ lineJobTotalAccumulation });
};
const setLineCurrentShiftProductions = (state, { lineCurrentShiftProductions }) => {
  return state.merge({ lineCurrentShiftProductions });
};
const setFinishGoodRejection = (state, { finishGoodRejection }) => {
  return state.merge({ finishGoodRejection });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_LINE_JOB_RECONCILIATION,
    actionFunction: setLineJobReconciliation,
  },
  {
    actionType: ActionTypes.SET_ACCUMULATION_LOADER,
    actionFunction: setAccumulationLoader,
  },
  {
    actionType: ActionTypes.SET_AUTO_RECONCILE_LOADER,
    actionFunction: setAutoReconcileLoader,
  },
  {
    actionType: ActionTypes.SET_NEW_LINE_JOB_ACCUMULATION,
    actionFunction: setAccumulationsForNewJob,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_EQUIPMENT_SHIFTS,
    actionFunction: setLineJobEquipmentShifts,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_EQUIPMENT_SHIFTS_LOADER,
    actionFunction: setLineJobEquipmentShiftsLoader,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_SHIFTS,
    actionFunction: setLineJobShifts,
  },
  {
    actionType: ActionTypes.SET_CURRENT_ACCUMULATION,
    actionFunction: setCurrentAccumulation,
  },
  {
    actionType: ActionTypes.SET_ACCUMULATION_MODAL_LOADER,
    actionFunction: setAccumulationModalLoader,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_TOTAL_ACCUMULATION,
    actionFunction: setLineJobTotalAccumulation,
  },
  {
    actionType: ActionTypes.SET_LINE_CURRENT_SHIFT_PRODUCTIONS,
    actionFunction: setLineCurrentShiftProductions,
  },
  {
    actionType: ActionTypes.SET_FINISH_GOOD_REJECTION,
    actionFunction: setFinishGoodRejection,
  },
];
